import React from 'react';
import {ConfigProvider, Switch} from "antd";
import {SwitchProps} from "antd/lib/switch";

export default function SwitchGreen({ ...props }: SwitchProps) {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#19BB4F',
        },
      }}
    >
      <Switch {...props} />
    </ConfigProvider>
  )
}
